export default __webpack_public_path__ + "static/joseph-46a581e1eb0296b6d4ae188c3909d958.jpeg";